import { render } from "./SubCluster.vue?vue&type=template&id=0aa5628b&ts=true"
import script from "./SubCluster.vue?vue&type=script&lang=ts"
export * from "./SubCluster.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__